/**
 * The root doc key the collaborative log lives under (RFC 0258: `whiffletree`,
 * was `thread`). Kept in its OWN dependency-free module — NOT in codec.ts —
 * because codec.ts imports fullfat `@automerge/automerge`, whose wasm auto-init
 * hangs silently in a SharedWorker (see mod-app shared-repo.worker.ts, Rule 1).
 * `bootstrap.ts` needs only this constant and is part of the worker's import
 * graph (`@mod/core/core`), so it must reach the key WITHOUT pulling codec.
 */
export const THREAD_KEY = 'whiffletree'
